import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Field, getFormValues, reduxForm } from 'redux-form';
import { addValidator, required } from 'redux-form-validators';
import { MODAL_CARD_FORM, hideModal } from '../../../../../modules/modals';
import { deleteImgs } from '../../../../helpers/Fields/EditorMedia/actions';
import EditorMedia from '../../../../helpers/Fields/EditorMedia/EditorMedia';
import SelectFieldAnt from '../../../../helpers/Fields/SelectFieldAnt';
import TreeSelectField from '../../../../helpers/Fields/TreeSelectField';
import UploadImageField from '../../../../helpers/Fields/UploadImageField';
import { createCard, getCategoriesUp, updateCard } from '../../../actions';
import Modal from 'react-modal';
import TextField from './components/TextField/TextField';
import TextFieldWysiwyg from './components/TextFieldWysiwyg/TextFieldWysiwyg';
import SwitchField from '../../../../helpers/Fields/SwitchField';
import './style.scss';
import InputField from '../../../../helpers/Fields/InputField';

const textValidate = addValidator({
  validator: function(options, value, allValues) {
    let tmp = value.trim().replace(/<p>/g, '').replace(/<\/p>/g, '').replace(/<br\/>/g, '').replace(/<br>/g, '').replace(/ /g, "")
    if(!tmp){
      return {
        id: "form.errors.question",
        defaultMessage: 'is required',
      }
    }
    return true
    
  }
})

export class FormContent extends Component {
  static contextTypes = {formatMessage: PropTypes.any};
  constructor(props) {
    super(props)
    this.deleteImages = [];
    this.state = {
      spinner: true,
      modal: false,
    }
    this.refAnswers = React.createRef();
    this.refQuestion = React.createRef();
  }

  componentWillUnmount(){
    if(this.deleteImages.length){
      deleteImgs(this.deleteImages)
    }
  }

  addedImage = (src) => {
    this.deleteImages.push(src);
  }

  submit = async (value) => {
    const {updateCard, createCard, hideModal, getCategoriesUp, subject_selcted} = this.props;
    this.deleteImages = [];
    if(value.id){
      await updateCard(value)
      this.props.handleClose();
    } else {
      await createCard(value);
      this.setState({modal: true})
    }
  }

  render() {
    const {formatMessage} = this.context;
    const {handleSubmit, handleClose, change} = this.props;
    const {categories, subjects, valuesForm} = this.props;
    const {modal} = this.state;

    let tree = [];

    if(valuesForm && valuesForm.subject_id){
      categories.filter(_i => _i.subject_id == valuesForm.subject_id).forEach(cat => {
        if(!cat.parent_id){
          tree.push({
            title: cat.name,
            value: cat.id,
            children: []
          })
        }
      });
    }
    

    categories.forEach(cat => {
      if(cat.parent_id){
        tree.forEach(item => {
          if(item.value == cat.parent_id){
            item.children.push({
              title: cat.name,
              value: cat.id,
            })
          }
        })
      }
    });

    return <form className='CardFormData' onSubmit={handleSubmit(this.submit)}>
      <Modal
        isOpen = {modal}
        style = {{
            overlay : {zIndex: 9999999},
        }}
        onRequestClose={() => {}}
        overlayClassName = "custom-modal"
        className = "custom-modal-content create-dialog-modal-content"
      >
        <div className="create-dialog-modal-content__header">
          <div className="create-dialog-modal-content__title">{formatMessage('msgTextCloseCreateCardModal')}</div>
        </div>
        <div className="create-dialog-modal-content__body">
          <div className="create-dialog-form form-quiz-create">
            <div className="col-xs-12 text-center word-wrap-break" style={{marginBottom: 10}}>{formatMessage('msgTextCreateCardModal')}</div>
            <div className="create-dialog-form__group flex">
              <button 
                className="btn btn-primary" 
                type="button" 
                onClick={() => {
                  this.setState({modal: false});
                  this.props.reset();
                }}
              >{formatMessage('Yes')}</button>
              <button className="btn btn-warning" type="button" onClick={() => {this.props.hideModal({ modalType : MODAL_CARD_FORM})}}>{formatMessage('No')}</button>
            </div>
          </div>
          
        </div>
      </Modal>
      <Field 
        name='subject_id'
        label={formatMessage('cardSubject')}
        component={SelectFieldAnt}
        handleChange={() => {
          change('category_id', '')
        }}
        options={subjects.map(_i => ({value: _i.id, title: _i.name}))}
        validate={[required()]}
      />
      <Field 
        name='category_id'
        label={formatMessage('cardCategory')}
        component={TreeSelectField}
        tree={tree}
        validate={[required()]}
      />
      <Field name='is_show' label={formatMessage('cardQuestionShow')} component={SwitchField} />
      <Field name='question_img' label={formatMessage('cardQuestionImg')} component={UploadImageField} />
      <Field name='question_img_alt' label={formatMessage('cardQuestionImgAlt')} component={InputField} />
      <Field name="question" label={formatMessage('cardQuestion')} validate={[textValidate()]} component={TextField} />
      <Field name='answer_img' label={formatMessage('cardAnswerImg')} component={UploadImageField} />
      <Field name='answer_img_alt' label={formatMessage('cardAnswerImgAlt')} component={InputField} />
      <Field name="answer" label={formatMessage('cardAnswer')} validate={[textValidate()]} component={TextField} />
      {/* <Field name="answer" hideUpload label={formatMessage('cardAnswer')} ref={this.refAnswers} withRef addedImage={this.addedImage} validate={[textValidate()]} component={EditorMedia} /> */}
      <div className="create-dialog-form__group flex" style={{justifyContent: 'center', marginTop: 20,
            flexDirection: 'row'}}>
           <button className="btn btn-primary" type="submit">{formatMessage('btnModalSaveCard')}</button>
        </div>
    </form>;
  }
}

const FormContentData = reduxForm({
  form: 'form_card',
  enableReinitialize: true,
})(FormContent);

const mapStateToProps = (state, ownProps) => ({
  valuesForm: getFormValues('form_card')(state),
  categories: state.card.categories_all,
  subject_selcted: state.card.subject_selcted,
  subjects: state.card.subjects,
})

const mapDispatchToProps = {
  createCard,
  updateCard,
  getCategoriesUp,
  hideModal,
}

export default connect(mapStateToProps, mapDispatchToProps)(FormContentData);




// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/components/Card/components/CardModal/components/FormContent.jsx